import { render, staticRenderFns } from "./AgentTransactionsReportTrademarkObjectionToUsList.vue?vue&type=template&id=49de281c&"
import script from "./AgentTransactionsReportTrademarkObjectionToUsList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportTrademarkObjectionToUsList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportTrademarkObjectionToUsList.vue?vue&type=style&index=0&id=49de281c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports